<template>
<div class="chapter">
<div class="inner_page">
<div epub:type="cover" id="cover">
<img alt="The Company She Keeps" class="cover-image" role="doc-cover" src="images/the-company-she-keeps-1.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// cover.vue?56704ca6